module.exports = __webpack_public_path__ + "assets/img/thumb-Australian-Seniors-Content-Marketing.5b60708d.jpg";